<template>
  <div class="vpolice-school">
    <!-- <Header></Header> -->
    <!-- 微警校 -->
    <div class="index">
      <!-- 全部警察 -->
      <!-- <Police></Police> -->

      <!-- 专题管理 -->
      <!-- <MaticManage></MaticManage> -->

      <!--政工专题  -->
      <PoliticalWork></PoliticalWork>

      <!-- 四星级精品 -->
      <StarBoutique></StarBoutique>

      <!-- 十大精品课程参赛作品 -->
      <!-- <TenEntries></TenEntries> -->

      <!-- 精选评比 -->
      <!-- <MicroClass></MicroClass> -->

      <!-- 专题微课 -->
      <RecentlyReleas></RecentlyReleas>

      <!-- 最新发布 -->
      <LatestRelease></LatestRelease>

      <!-- 排行 -->
      <!-- <Ranking></Ranking> -->

      <!-- 培训班课程 -->
      <!-- <TrainingCourse></TrainingCourse> -->

      <!-- 火爆点评 -->
      <!-- <HotComments></HotComments> -->
      <!-- 选择省市区 -->
    </div>
    <!-- <linecom></linecom> -->
  </div>
</template>

<script>
import Header from '../header/index';
import Police from './components/police/index';
import MaticManage from './components/maticmanage/index';
import TenEntries from './components/tenentries/index';
import StarBoutique from './components/starboutique/index';
import MicroClass from './components/microclass/index';
import TrainingCourse from './components/trainingcourse/index';
import RecentlyReleas from './components/recentlyreleas/index';
import HotComments from './components/hotcomments/index';
import Ranking from './components/ranking/index';
import LatestRelease from './components/latestRelease/index';
import PoliticalWork from './components/politicalWork/index';
// import * as diss from '@/api/studyClass/disstation.js';
import linecom from '@/components/linecom/index';
export default {
  components: {
    Header,
    Police,
    MaticManage,
    TenEntries,
    StarBoutique,
    MicroClass,
    TrainingCourse,
    RecentlyReleas,
    HotComments,
    Ranking,
    linecom,
    LatestRelease,
    PoliticalWork,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.vpolice-school {
  opacity: 1;
  .index {
    width: 1200px;
    margin: 0 auto;
  }
}
.gitern {
  height: 1px;
  width: 100%;
  background: linear-gradient(139deg, #1492ff, #d51919);
}
</style>